import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LagrofyIso } from '../../atoms/AgroLogo/logos';
import { AgroLabel } from '../../atoms/AgroLabel';
var AgroExclusiveRegistered = function AgroExclusiveRegistered(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'light' : _ref$variant;
  return /*#__PURE__*/React.createElement(Container, {
    variant: variant
  }, /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(LagrofyIso, null)), /*#__PURE__*/React.createElement("span", null, "Exclusivo registrados"));
};
AgroExclusiveRegistered.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark'])
};
AgroExclusiveRegistered.displayName = 'AgroExclusiveRegistered';
export { AgroExclusiveRegistered };
var Container = styled(AgroLabel).withConfig({
  displayName: "AgroExclusiveRegistered__Container",
  componentId: "sc-6b3l8y-0"
})(["padding:4px 8px;gap:4px;border-radius:4px;", ";"], function (_ref2) {
  var variant = _ref2.variant,
    theme = _ref2.theme;
  return variant === 'dark' ? css(["background:", ";color:", ";border:1px solid ", ";padding:3px 8px;"], theme.colors.white, theme.colors.gray900, theme.colors.gray700) : css(["background:", ";color:", ";"], theme.colors.black, theme.colors.white);
});
var LogoWrapper = styled.span.withConfig({
  displayName: "AgroExclusiveRegistered__LogoWrapper",
  componentId: "sc-6b3l8y-1"
})(["display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;"]);